export const STORES_DISCOUNT_CYC = {
  SELFIE: 30,
  'Mundo Petit': 30
}

export const STORES_REDIRECT_SHIPPING_STEP = []

export const LOCAL_PICKUP_DELIVERY_TIME = {}

export const CUSTOM_STORES_NAME = {}

export const STORES_WITHOUT_LOCAL_PICKUP_BADGE = []

export const STORES_WITHOUT_CNC_BADGE = []

export const CUSTOM_LOCAL_NAME = {
  "L'Occitane": 'Retiro en Tienda'
}

export const ONLY_CHECKOUT = [
  'Opaline',
  'Colloky'
]

export const DIFFERENT_REGION_NAME = [
  'Opaline',
  'Colloky'
]

export const CHANGE_ORDER = [
  'Opaline',
  'Colloky'
]

export const KILLSTORE_LOCAL_PICKUP = 'gid://shopify/Location/78332035347'

export const CUSTOM_BILLING_BUTTON = {
  'HARD WORK': '#F7931E',
  'STEEL PRO SAFETY': '#F7931E',
  TECNOBOGA: '#F7931E',
  EDELBROCK: '#F7931E',
  'BEST SHOES': '#F7931E',
  Vicsa: '#F7931E',
  'Safety Store B2B': '#F7931E',
  'SAFETY OUTLET': '#F7931E',
  'SAFETY STORE': '#F7931E',
  'Vitel Energia': '#33C028'
}
